// @ts-check
/**
 * @file InstallPwaCard.jsx
 * @location src/components/push/InstallPwaCard.jsx
 * @role iOS Safari + 비-standalone 사용자에게 「홈 화면에 추가」 안내.
 *   PWA 설치 후에만 push 수신 가능(iOS 16.4+ 제약).
 */

/**
 * @param {{ show: boolean, onDismiss: () => void }} props
 */
export function InstallPwaCard({ show, onDismiss }) {
  if (!show) return null;
  return (
    <div className="install-pwa-card" role="region" aria-label="앱 설치 안내">
      <button
        type="button"
        className="install-pwa-close"
        aria-label="닫기"
        onClick={onDismiss}
      >
        ×
      </button>
      <h4>온점을 홈 화면에 추가</h4>
      <ol>
        <li>Safari의 <strong>공유 버튼</strong>을 탭</li>
        <li>「홈 화면에 추가」 선택</li>
        <li>추가된 아이콘부터 실행해 알림을 켜 주세요</li>
      </ol>
    </div>
  );
}
